import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectToolCollection,
  alignLeft,
  alignRight,
  alignTop,
  alignBottom,
  alignHorizontal,
  alignVertical,
  alignItemsLeft,
  alignItemsCenter,
  alignItemsRight,
} from "../../../actions";
import Intro from "./Intro";
import AlignItems from "./AlignItems";
import AlignToProduct from "./AlignToProduct";
import CenterAll from "./CenterAll";
import "./AlignTools.css";

class AlignTools extends React.Component {
  componentDidMount() {
    // Set 'Align' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Align" });
  }

  render() {
    return (
      <div className="tools-container tools-container--aligntools">
        <Intro />
        <AlignItems
          handleAlignLeft={this.props.alignItemsLeft}
          handleAlignCenter={this.props.alignItemsCenter}
          handleAlignRight={this.props.alignItemsRight}
        />
        <AlignToProduct
          handleAlignToLeft={this.props.alignLeft}
          handleAlignToRight={this.props.alignRight}
          handleAlignToTop={this.props.alignTop}
          handleAlignToBottom={this.props.alignBottom}
          handleAlignToHorizontal={this.props.alignHorizontal}
          handleAlignToVertical={this.props.alignVertical}
        />
        <CenterAll />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  // Pass result of selecToolCollection to reducers
  return bindActionCreators(
    {
      selectToolCollection,
      alignLeft,
      alignRight,
      alignTop,
      alignBottom,
      alignHorizontal,
      alignVertical,
      alignItemsLeft,
      alignItemsCenter,
      alignItemsRight,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(AlignTools);
